import { api } from 'common';

import { ExportExternalDocumentPacketFormFields } from './FormFields';
import { ExportExternalDocumentPacketDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const exportExternalDocumentPacketConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'exportDocument',
  defaultConfig: {
    externalDocumentPacket: {
      sourceBlockName: '',
    },
    exportReason: api.FlowDefinition.ExportExternalDocumentPacketReasons.OutOfScope,
  },
  configFields: {
    schema: api.FlowDefinition.ExportExternalDocumentPacketBlockConfigSchema,
    FormFields: ExportExternalDocumentPacketFormFields,
  },
  documentationMarkdown: ExportExternalDocumentPacketDocumentation,
};
